import React from "react";
import {
  ClaimPolicyPatchSummaryResponse,
  claimPolicyPatchDashboardApi,
} from "../../../../../api/claimPolicyPatchDashboardApi";
import { ROUTES } from "../../../../../config/routes";
import { WidgetComponentProps } from "../../types";
import { useWidgetData } from "../../useWidgetData";
import { CardError, CardLoading, Freshness, Kpi, KpiGrid, formatNumber } from "../../ui";

const WINDOW_OPTIONS = [7, 30, 90];

const ClaimPolicyCard: React.FC<WidgetComponentProps> = ({ filters }) => {
  const requested = Number(filters.windowDays);
  const windowDays = WINDOW_OPTIONS.includes(requested) ? requested : 30;

  const { data, loading, error, reload } = useWidgetData<ClaimPolicyPatchSummaryResponse>(
    `claim-policy:${windowDays}`,
    () => claimPolicyPatchDashboardApi.getSummary(windowDays)
  );

  if (loading && !data) return <CardLoading />;
  if (error) return <CardError message={error} onRetry={reload} />;
  if (!data) return null;

  const claimsInWindow = Number(data.patchedClaimsInWindow) || 0;
  const videosInWindow = Number(data.patchedVideosInWindow) || 0;

  return (
    <>
      <KpiGrid columns={2}>
        <Kpi
          label={`Claims patched (${windowDays}d)`}
          value={claimsInWindow}
          tone={claimsInWindow > 0 ? "info" : "neutral"}
          hint={`${formatNumber(data.totalPatchedClaims)} all time`}
          to={ROUTES.CLAIM_POLICY_PATCH_DASHBOARD_UPDATED_CLAIMS}
          emphasis
        />
        <Kpi
          label={`Videos patched (${windowDays}d)`}
          value={videosInWindow}
          tone={videosInWindow > 0 ? "info" : "neutral"}
          hint={`${formatNumber(data.totalPatchedVideos)} all time`}
          to={ROUTES.CLAIM_POLICY_PATCH_DASHBOARD_OVERVIEW}
        />
      </KpiGrid>

      <div className="home-card__meta">
        {data.lastMonetisationSyncAt ? (
          <Freshness label="Monetisation synced" at={data.lastMonetisationSyncAt} />
        ) : (
          <span className="home-muted">
            <i className="pi pi-clock" /> Monetisation not synced yet
          </span>
        )}
      </div>
    </>
  );
};

export default ClaimPolicyCard;
